import { useEffect, useRef } from "react";
import { motion } from "framer-motion";

export default function Preloader({ onComplete }) {
  const minDone = useRef(false);
  const ended = useRef(false);
  const fired = useRef(false);

  const tryComplete = () => {
    if (minDone.current && ended.current && !fired.current) {
      fired.current = true;
      onComplete?.();
    }
  };

  useEffect(() => {
    const t = setTimeout(() => {
      minDone.current = true;
      tryComplete();
    }, 1500);
    return () => clearTimeout(t);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <motion.div
      initial={{ y: 0 }}
      exit={{ y: "-100%" }}
      transition={{ duration: 0.7, ease: [0.76, 0, 0.24, 1] }}
      className="fixed inset-0 z-[300] bg-black flex items-center justify-center overflow-hidden"
      data-testid="intro-preloader"
    >
      <video
        src="/intro.mp4"
        autoPlay
        muted
        playsInline
        preload="auto"
        onEnded={() => {
          ended.current = true;
          tryComplete();
        }}
        onError={() => {
          ended.current = true;
          minDone.current = true;
          tryComplete();
        }}
        className="absolute inset-0 w-full h-full object-contain"
        data-testid="intro-video"
      />
    </motion.div>
  );
}
